export class Password {
    constructor() {
        this.form = document.querySelector('#form-password');
        this.submitButton = document.querySelector('.submitButton');

        this.divAction = document.querySelector('.action');
        this.divSuccess = document.querySelector('.action-success');
        this.divError = document.querySelector('.action-error');

        this.initService();
    };

    initService() {
        this.submitButton.addEventListener('click', event => {
            event.preventDefault();
            this.reset();
            this.submit();
        });
    };
    
    submit() {
        let request = new Request('POST', this.form.getAttribute('action'));
        request.formData = this.form;
        request.call((response) => {
            if(response.status == 'ok') {
                this.success();
            } else {
                this.error();
            }
        });
    };

    success() {
        this.divAction.classList.add('d-none');
        this.divSuccess.classList.remove('d-none');
    }

    error() {
        this.divError.classList.remove('d-none');
    }

    reset() {
        this.divError.classList.add('d-none');
    }
};
